import React from "react";

export enum ButtonType {
  Action,
  Warning,
  Neutral,
}

export enum ButtonSize {
  ExtraSmall,
  Small,
  Large,
}

interface Props {
  text: string;
  type: ButtonType;
  size?: ButtonSize;
  onClick?: any;
  fill?: boolean;
  loading?: boolean;
  disabled?: boolean;
  startIcon?: any;
  dataTest?: string;
  className?: string;
}

const TempoButton: React.FC<Props> = React.memo((props) => {
  let className = "";
  switch (props.type) {
    case ButtonType.Action:
      className = "tempo-button action";
      break;
    case ButtonType.Neutral:
      className = "tempo-button neutral";
      break;
    case ButtonType.Warning:
      className = "tempo-button warning";
      break;
    default:
      className = "tempo-button";
  }
  className = className.concat(props.fill ? " fill" : "");
  className = className.concat(props.startIcon ? " icon-button" : "");
  className = className.concat(props.size === ButtonSize.Small ? " small" : "");
  className = className.concat(
    props.size === ButtonSize.ExtraSmall ? " extra-small" : ""
  );
  className = className.concat(props.disabled ? " disabled" : "");

  className = className.concat(props.className ? " " + props.className : "");

  return (
    <div
      className={className}
      onClick={!props.disabled ? props.onClick : null}
      data-test={props.dataTest}
    >
      {props.loading && (
        <img
          src={"/images/loader-anim.svg"}
          style={{ width: 21, height: 21, boxSizing: "initial" }}
          alt={"Loader Spinner"}
          width={21}
          height={21}
          className="max-w-none"
        />
      )}
      {props.startIcon && <div className="start-icon">{props.startIcon}</div>}
      <div className="button-text">{props.text}</div>
    </div>
  );
});

export default TempoButton;
